<template>
    <div class="mx-md-5 my-4">
        <div class="container-fluid w-100">
            <div class="notification-list mb-2">
                <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a>
            </div>
            
            <div class="pt-5 d-md-flex w-100 flex-wrap">
                <div class="mr-md-auto mt-2">
                    <h2 class="default fwb">Role : {{role.name}}</h2><br>
                </div>
            </div>
            <div class="ml-md-auto float-right">
                <ul class="list-none p-0 d-md-flex align-items-end gap-2 float-right">
                    <b-form-group>
                        <b-form-input class="float-right" v-model="searchQuery" type="text" placeholder="Rechercher une permission"></b-form-input>
                    </b-form-group>
                </ul>
            </div>
            <div class="mt-5">
                <div class="bg-transparent d-none d-md-block">
                    <form ref="form" @submit.stop.prevent="handleSubmit" id="form">
                        <b-form-group>
                            <div class="container">
                                <div class="d-flex">
                                    <div class="overflow-auto p-2 mr-3">
                                        <div v-for="(group, key) in this.permissions" :key="key">
                                            <b-form-group v-slot="{ ariaDescribedby }">
                                                <div class="d-flex align-items-center">
                                                <b-form-checkbox v-model="selectAll[key]" @input="togglePermissions(group)">
                                                    {{ group[0].feature.nom_feature }}
                                                </b-form-checkbox>
                                                </div>
                                                <div class="container">
                                                <div class="d-flex">
                                                    <div class="overflow-auto p-2 mr-3" style="max-height: 400px;">
                                                    <b-form-checkbox-group name="complementaires" v-model="selectedPermissions" text-field="name" :aria-describedby="ariaDescribedby" switch>
                                                        <b-form-checkbox v-for="permission in group" :value="permission.id" :key="permission.id">
                                                        <span>{{ permission.name }}</span>
                                                        </b-form-checkbox>
                                                    </b-form-checkbox-group>
                                                    </div>
                                                </div>
                                                </div>
                                            </b-form-group>
                                        </div>
                                        <!-- <b-form-checkbox-group name="role" v-model="selectedPermissions" text-field="name">
                                            <b-form-checkbox v-for="permission in filteredPermissions" :value="permission.id" :key="permission.id">
                                                <span>{{ permission.name }}</span>
                                            </b-form-checkbox>
                                        </b-form-checkbox-group> -->
                                    </div>
                                </div>
                            </div>
                        </b-form-group>
                        <b-row>
                            <b-button variant="success" class="mt-1" @click="handleSubmit">Soumettre</b-button>
                        </b-row>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "ModalAlerte",

    components: {
    },
    computed: {
        ...mapGetters(["permissions","role"]),

        hasText() {
            return this.text.length > 0 ? true : false;
        },
    },

    data() {
        return {
            selectAll: {},
            regroupement: null,
            selectedPermissions: [],
            role_id: this.$route.params.id,
            searchQuery: '',
        }
    },

    methods: {
        getPermissionsByGroup() {
            let args = {
                offset: this.offset,
                limit: this.limit,
            };

            this.$store.dispatch("getPermissionsByGroup", { args: args });
        },
        getPermissions() {
            let args = {
                offset: this.offset,
                limit: this.limit,
            };

            this.$store.dispatch("getPermissions", { args: args });
        },
        getRole() {
            let args = {
                role: this.role_id,
            };

            this.$store.dispatch('getRole', { args });
        },
        togglePermissions(group) {
            const groupPermissions = group.map(permission => permission.id);
            if (this.selectAll[group[0].feature.id]) {
                this.selectedPermissions = this.selectedPermissions.concat(groupPermissions);
            } else {
                this.selectedPermissions = this.selectedPermissions.filter(permission => !groupPermissions.includes(permission));
            }
        },
        // regrouperParFeature() {
        //     const regroupement = this.permissions.reduce((acc, objet) => {
        //         const featureId = objet.feature_id;
        //         if (!acc[featureId]) {
        //             // Si l'ID de la fonctionnalité n'existe pas encore dans le regroupement, on l'ajoute avec un tableau vide.
        //             acc[featureId] = [];
        //         }
        //         // On ajoute l'objet courant au tableau correspondant à l'ID de la fonctionnalité.
        //         acc[featureId].push(objet);
        //         return acc;
        //     }, {});
        //     console.log(regroupement);

        //     return regroupement;
        // },

        handleSubmit() {
            // console.log(this.selectedPermissions);
            let args = {
                permissionIds: this.selectedPermissions,
                roleId: this.role.id,
            }
            console.log(args);
            let successMessage = this.$i18n.t('message.PermissionAssigned');
            let errorMessages = {
                generic: this.$i18n.t('message.genericError'),
                error: this.$i18n.t('message.error')
            };

            this.$store.dispatch('permissions', { args, errorMessages, successMessage })

        },
        filteredPermissions(permissionName) {
            // Créer un tableau vide pour stocker les permissions filtrées
            const filteredPermissions = [];

            // Parcourir chaque groupe dans this.permissions
            this.permissions.forEach(group => {
                // Appliquer le filtre sur chaque permission du groupe
                const filteredGroup = group.filter(permission => {
                    return permission.name.toLowerCase().includes(permissionName.toLowerCase());
                });

                // Ajouter les permissions filtrées au tableau final
                filteredPermissions.push(...filteredGroup);
            });

            // Retourner les permissions filtrées
            return filteredPermissions;
        },
    },
    created(){
        // this.regroupement = this.regrouperParFeature(this.objets);
        // console.log(this.regroupement);
    },
    mounted() {
        this.getRole();
        this.getPermissionsByGroup();
        
        this.$watch(
            () => this.role.permissions,
            (permissions) => {
                this.selectedPermissions = permissions.map((permission) => permission.id);
            }
        );
    },

}
</script>